import {tap} from "rxjs/operators"
import AuthServiceType from "./AuthServiceType"

// Http
import HttpService from "../../http/services/HttpService/HttpService"
import HttpServiceType from "../../http/services/HttpService/HttpServiceType"

// Constants
import {AUTH_COOKIE_KEY, AuthEndpoint} from "../constants"
import {RequestHeader, RequestMethod} from "../../../constants"

// Utils
import Utils from "../../../utils/Utils"

const AuthService: AuthServiceType & HttpServiceType = Object.create(HttpService);

AuthService.fetchCurrentUser = function fetchCurrentUser() {
    return this.request(`${this.getApiUrl()}${AuthEndpoint.USER}`, {
        headers: this.getAuthHeader(),
    })
};

AuthService.getAuthHeader = function getAuthHeader() {
    return {
        [RequestHeader.AUTHORIZATION]: `Bearer ${this.getToken()}`,
    }
};

/**
 * @param requestDto
 */
AuthService.signIn = function signIn(requestDto: FormData) {
    return this.request(`${this.getApiUrl()}${AuthEndpoint.SIGN_IN}`, {
        method: RequestMethod.POST,
        body: requestDto,
        headers: {
            [RequestHeader.AUTHORIZATION]: `basic ${Utils.base64Encode("web_app:")}`,
        },
    })
};

AuthService.signOut = function signOut() {
    return this.request(`${this.getApiUrl()}${AuthEndpoint.SIGN_OUT}`, {
        headers: this.getAuthHeader(),
        method: RequestMethod.POST,
    }).pipe(tap(() => AuthService._removeToken()))
};

/**
 * @param token
 * @param expiresIn
 */
AuthService.saveToken = function saveToken(token, expiresIn) {
    this.token = token;

    document.cookie = `${AUTH_COOKIE_KEY}=${token};path=/;max-age=${expiresIn}`;
};

/**
 * @private
 */
AuthService._removeToken = function removeToken() {
    this.token = null;

    document.cookie = `${AUTH_COOKIE_KEY}=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

AuthService.getToken = function getToken() {
    return this.token
};

AuthService.init = function init() {
    this.token = getTokenFromCookie();

    return this
};

function getTokenFromCookie() {
    const cookies = document.cookie.split(";");
    const authCookie = cookies.find(c => c.indexOf(AUTH_COOKIE_KEY) !== -1);

    if (typeof authCookie === "undefined") {
        return null
    }

    const [, token] = authCookie.split("=");

    if (typeof token === "undefined") {
        return null
    }

    return token
}

export default AuthService
